import { Component, OnInit } from '@angular/core';
import { AllVideosDataService } from 'src/app/core/service/AllVideosDataService';

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss']
})

export class SearchFilterComponent implements OnInit {

  filteredVideos : any;
  subjectList: any = {};
  systemList: any = {};
  instructorList : any = {};


  updatedFilteredVideos : any = {};
  listWithSubList : any = {};

  systemSelectedText : any = "";
  subjectSelectedText : any = "";
  instructorSelectedText : any = "";
  

  filteredVideosOriginal : any;

  constructor(private allvideos : AllVideosDataService) { }

  showResetTag(){
    if(this.showSubjectTag() || this.showSystemTag() || this.showInstructorTag()){
      return true;
    }else{
      return false;
    }
  }

  subjectSelected(subject){
     // console.log(JSON.stringify(subject));
      this.subjectSelectedText = subject;
      this.initFilterVideosAgain();
      this.initSubjectList();
      this.initSystemList();
      this.initInstructorList();
      
  }

  systemSelected(subject){
  //  console.log(JSON.stringify(subject));
    this.systemSelectedText = subject;
    this.initFilterVideosAgain();
    this.initSubjectList();
      this.initSystemList();
      this.initInstructorList();
      
}


instructorSelected(instructor){

  this.instructorSelectedText = instructor;
  this.initFilterVideosAgain();
  this.initSubjectList();
    this.initSystemList();
    this.initInstructorList();


}

resetSelection(){
  this.systemSelectedText = "";
  this.subjectSelectedText= "";
  this.instructorSelectedText = "";
  this.initSearchFilter();
}




removeSubjectText(){
 // console.log("removeSubjectText");
  this.subjectSelectedText= "";
      this.initFilterVideosAgain();
      this.initSubjectList();
      this.initSystemList();
      this.initInstructorList();
}

removeSystemText(){
 // console.log("removeSystemText");
      this.systemSelectedText = "";
      this.initFilterVideosAgain();
      this.initSubjectList();
      this.initSystemList();
      this.initInstructorList();
}


removeInstructorText(){
  this.instructorSelectedText = "";
  this.initFilterVideosAgain();
      this.initSubjectList();
      this.initSystemList();
      this.initInstructorList();

}

  showSubjectTag(){
    if(this.subjectSelectedText != undefined ){
      if(this.subjectSelectedText.length>0){
        return true;
      }else{
        return false;
      }
      
    }else{
      return false;
    }
  }

  showSystemTag(){
    if(this.systemSelectedText != undefined ){
      if(this.systemSelectedText.length>0){
        return true;
      }else{
        return false;
      }
      
    }else{
      return false;
    }
  }

  showInstructorTag(){
    if(this.instructorSelectedText != undefined ){
      if(this.instructorSelectedText.length>0){
        return true;
      }else{
        return false;
      }
      
    }else{
      return false;
    }
  }


  initSearchFilter(){
    if(localStorage.getItem("all_videos")!=null){
      this.filteredVideosOriginal = JSON.parse(localStorage.getItem("all_videos"));
      //this.filteredVideos = this.filteredVideosOriginal;
    }
    this.initFilterVideosAgain();
    this.initSubjectList();
    this.initSystemList();
    this.initInstructorList();
    
  }

 ngOnInit() {
    
    this.initSearchFilter();
    this.allvideos.filteredSearchList.subscribe(message => {
      if(message == ""){
        this.filteredVideosOriginal = [];  
       // this.filteredVideos = [];
      }else{
        this.filteredVideosOriginal = message;
      //  this.filteredVideos = this.filteredVideosOriginal;
      }
      
      //console.log("Filtered From Event"+JSON.stringify(message));
      //console.log("Filtered Videos"+JSON.stringify(this.filteredVideosOriginal));
      this.initFilterVideosAgain();
      this.initSubjectList();
      this.initSystemList();
      this.initInstructorList();
    });


    
  }

  //fliter videos form system and subject
  initFilterVideosAgain(){
      this.filterVideos();
  }

  filterVideosFromInstructor(filtetedVideosLocally){
      
    this.filteredVideos = filtetedVideosLocally.filter(videoItem => {
      
      //console.log("System In - "+videoItem.tags.system);
     // console.log("Subject System - "+this.systemSelectedText+"---"+this.subjectSelectedText);
      if(this.instructorSelectedText != ""){
        if(videoItem.instructorName == this.instructorSelectedText){
          console.log("One");
          return videoItem;
        }  
      }else{
        return videoItem;  
      }
      
    });

    this.allvideos.updateCurrentFilteredVideoList(this.filteredVideos);
  }
  
  filterVideos(){
     
    let filteredVideosFirst = this.filteredVideosOriginal.filter(videoItem => {
      
      //console.log("System In - "+videoItem.tags.system);
     // console.log("Subject System - "+this.systemSelectedText+"---"+this.subjectSelectedText);
      if(this.systemSelectedText != "" && this.subjectSelectedText == ""){
        if(videoItem.tags.system == this.systemSelectedText){
          console.log("One");
          return videoItem;
        }  
      }else if(this.subjectSelectedText != "" && this.systemSelectedText == ""){
        if(videoItem.tags.subject == this.subjectSelectedText){
          console.log("One Two");
          return videoItem;
        }  
      }else if(this.subjectSelectedText == "" && this.systemSelectedText == ""){
          console.log("Three");
          return videoItem; 
      }else{
        if(videoItem.tags.system == this.systemSelectedText
          && videoItem.tags.subject == this.subjectSelectedText){
            console.log("Four");
          return videoItem;
        }  
      }
      
    });
    console.log("Filtered Videos With Out Instructor"+JSON.stringify(this.filteredVideos));
    this.filterVideosFromInstructor(filteredVideosFirst);
    console.log("Filtered Videos After Instructor"+JSON.stringify(this.filteredVideos));
   
  }


  initSubjectList(){
    this.subjectList = [];
    for(var i = 0 ;i<this.filteredVideos.length;i++){
      var subject = this.filteredVideos[i].tags.subject;
      if (subject in this.subjectList) {
        //  console.log("Push again");
          this.subjectList[subject].push( this.filteredVideos[i]);
      } else {
      //  console.log("Set item for first");
        this.subjectList[subject]  = [this.filteredVideos[i]];
      }
      
    }
   // console.log("Subjects : = "+JSON.stringify(this.subjectList));

  }


  initSystemList(){
    this.systemList = [];
    for(var i = 0 ;i<this.filteredVideos.length;i++){
      var system = this.filteredVideos[i].tags.system;
      if (system in this.systemList) {
        //  console.log("Push again");
          this.systemList[system].push( this.filteredVideos[i]);
      } else {
      //  console.log("Set item for first");
        this.systemList[system]  = [this.filteredVideos[i]];
      }
      
    }
   // console.log("system : = "+JSON.stringify(this.subjectList));

  }


  /**
   * Get List of Instructors in Video
   */
  initInstructorList(){
    this.instructorList = [];
    for(var i = 0 ;i<this.filteredVideos.length;i++){
      var instructorName = this.filteredVideos[i].instructorName;

      if (instructorName in this.instructorList) {
        //  console.log("Push again");
          this.instructorList[instructorName].push( this.filteredVideos[i]);
      } else {
      //  console.log("Set item for first");
        this.instructorList[instructorName]  = [this.filteredVideos[i]];
      }
    }
   // console.log("instructorList  : = "+JSON.stringify(this.instructorList));
  
   
     

  }

  




}
